export const GET_STARTED_CLICK = "Community Get Started Clicked";
export const INTERST_SHOWN = "Community Topic Shown";
export const COMM_ADD_CLICK = "Community Topic Add Button Selected";
export const PRIMARY_CLICK = "Community Next Clicked";
export const LOADING_SCREEN = "Community Loading Screen Shown";
